{
	"backToManageDeclarations": "Tillbaka till Hantera deklarationer",
	"kpi": {
		"quantity": "Kvantitet",
		"carbonSavings": "Koldioxidreduktioner"
	},
	"downloadAllDeclarations": "Ladda ner alla deklarationer",
	"errors": {
		"notFound": "Projektet hittades inte"
	}
}
